import createIcon from '../../createIcon';

/**
 * @component @name PlaylistRemove
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgOEgzVjEwSDE0VjhaTTE0IDRIM1Y2SDE0VjRaTTMgMTRIMTBWMTJIM1YxNFpNMTQuNDEgMjBMMTcgMTcuNDFMMTkuNTkgMjBMMjEgMTguNTlMMTguNDEgMTZMMjEgMTMuNDFMMTkuNTkgMTJMMTcgMTQuNTlMMTQuNDEgMTJMMTMgMTMuNDFMMTUuNTkgMTZMMTMgMTguNTlMMTQuNDEgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlaylistRemove = createIcon('PlaylistRemove', [
  [
    'path',
    {
      d: 'M14 8H3V10H14V8ZM14 4H3V6H14V4ZM3 14H10V12H3V14ZM14.41 20L17 17.41L19.59 20L21 18.59L18.41 16L21 13.41L19.59 12L17 14.59L14.41 12L13 13.41L15.59 16L13 18.59L14.41 20Z',
      key: '14e66k',
    },
  ],
]);

export default PlaylistRemove;
